import React from 'react';
import NumberOfUnreadMessages from '../Elements/NumberOfUnreadMessages';
import NumberOfUndownloadedFiles from '../Elements/NumberOfUndownloadedFiles';

// Collapsed-rail profile trigger: avatar initials + a notification dot. Toggles the
// shared ProfileMenuPopover (owned by BravoSidebar).
export default function ProfileRailTrigger({ loggedInUser, active, onToggle }) {
  if (!loggedInUser) return null;
  const fullName = `${loggedInUser.firstName} ${loggedInUser.lastName}`;
  const initials = `${(loggedInUser.firstName || ' ')[0]}${(loggedInUser.lastName || ' ')[0]}`.trim().toUpperCase();
  return (
    <button
      type='button'
      className={`nav-ico pm-trigger${active ? ' active' : ''}`}
      title={fullName}
      aria-label={'Profile'}
      onClick={onToggle}
    >
      <span className='pm-av'>{initials}</span>
      <span className='pm-dot'>
        <NumberOfUnreadMessages notificationsWithoutNumberDropDown={true} />
        <NumberOfUndownloadedFiles notificationsWithoutNumberDropDown={true} />
      </span>
    </button>
  );
}
